const Sidebar = () => null;

export default Sidebar;
